var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6026 0.662109H1.81927C1.526 0.66429 1.24535 0.781761 1.03797 0.989143C0.830589 1.19652 0.713118 1.47717 0.710938 1.77044V19.5538C0.713118 19.847 0.830589 20.1277 1.03797 20.3351C1.24535 20.5425 1.526 20.6599 1.81927 20.6621H11.3943V12.9288H8.79427V9.90378H11.3943V7.67878C11.3943 5.09544 12.9693 3.68711 15.2859 3.68711C16.0609 3.68711 16.8359 3.68711 17.6109 3.80378V6.49544H16.0193C14.7609 6.49544 14.5193 7.09544 14.5193 7.97044V9.89544H17.5193L17.1276 12.9204H14.5193V20.6621H19.6026C19.8959 20.6599 20.1765 20.5425 20.3839 20.3351C20.5913 20.1277 20.7088 19.847 20.7109 19.5538V1.77044C20.7088 1.47717 20.5913 1.19652 20.3839 0.989143C20.1765 0.781761 19.8959 0.66429 19.6026 0.662109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.55dcad2a6e8197b00a6f7828d39b8961.svg";
export { ForwardRef as ReactComponent };